import { createPortal } from "react-dom";
import { MailAccountForm, type MailAccountFormProps } from "./MailAccountForm";

interface MailAccountFormModalProps extends MailAccountFormProps {
  open: boolean;
  title?: string;
}

export function MailAccountFormModal({
  open,
  title,
  onCancel,
  account,
  ...formProps
}: MailAccountFormModalProps) {
  if (!open) return null;
  const heading = title ?? (account ? "メールアカウントを編集" : "メールアカウントを追加");

  return createPortal(
    <div className="mv2-modal-backdrop" role="dialog" aria-modal="true" aria-label={heading}>
      <div className="mv2-modal mv2-mail-account-modal">
        <div className="mv2-modal-header">
          <h2>{heading}</h2>
          <button type="button" className="mv2-modal-close" onClick={onCancel} aria-label="閉じる">×</button>
        </div>
        <div className="mv2-modal-body">
          <MailAccountForm
            account={account}
            onCancel={onCancel}
            {...formProps}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
}
